import { dateRangePagination } from './consts';

export default function (editor, opts = {}) {
  const bm = editor.BlockManager;
  const pfx = opts.pfx;

  const style = opts.defaultStyle
    ? `<style>
    .${pfx}-cont,
    .block {
      display: inline-block;
    }
  </style>`
    : '';

  if (opts.blocks.indexOf(dateRangePagination) >= 0) {
    bm.add(dateRangePagination, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" fill="currentColor" class="bi bi-calendar-range" viewBox="0 0 16 16">
        <path d="M9 7a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1M1 9h4a1 1 0 0 1 0 2H1z"/>
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
      </svg>
      <div class="gjs-block-label">${opts.label}</div>`,
      category: opts.category,
      content: `
        <div class="${pfx}" data-gjs-type="${pfx}"  data-gjs="${pfx}" style="display: flex;
        flex-direction: row;justify-content: space-between;">
        <div class="prev-date-range"><a class="page-link prev-date link-1" href="javascript:void(0)">Previous</a></div>
        <div class="date-range-div">Date Range</div>
        <div class="next-date-range"><a class="page-link next-date link-2" href="javascript:void(0)">Next</a></div>
        </div> 
        ${style}
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.label
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
